import { Button, Dialog, Typography } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";
import { useFetcher } from "react-router";

import { Resource as TResource } from "@/types";

export async function loader() {
  const allResourcesResponse = await fetch(
    `/api/client/onboarding_resources/all`
  );

  if (allResourcesResponse.status !== 200) {
    return { ok: false, error: allResourcesResponse.statusText };
  }

  const {
    data: { resources },
  } = await allResourcesResponse.json();

  return { ok: true, resources: resources as TResource[] };
}

import { Plus } from "lucide-react";

import { PortalContainerContext } from "@/contexts";

import { PendingAllResources } from "./PendingResources";
import Resource from "./Resource";

const ViewAllResourcesModal = () => {
  const { container } = use(PortalContainerContext);
  const { t } = useTranslation("onboarding");
  const fetcher = useFetcher<typeof loader>();

  const onModalOpen = () => {
    fetcher.submit({}, { action: "/onboarding/all-resources", method: "get" });
  };

  return (
    <Dialog
      trigger={
        <Button
          shape="link"
          intent="secondary"
          onClick={onModalOpen}
          SuffixIcon={Plus}
        >
          {t("resources.view_all")}
        </Button>
      }
      title={t("resources.modal.title")}
      description={t("resources.modal.description")}
      portalContainer={container as Element}
      size="large"
    >
      {fetcher.state === "loading" ? (
        <PendingAllResources />
      ) : fetcher.data?.ok === false ? (
        <Typography step="2" as="p" className="text-red-500">
          {fetcher.data?.error}
        </Typography>
      ) : (
        <ul className="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {fetcher.data?.resources?.map((resource) => (
            <Resource key={resource.url} resource={resource} />
          ))}
        </ul>
      )}
    </Dialog>
  );
};

export default ViewAllResourcesModal;
